import { TwcProduct } from '../../../twc-products';
import { TWC_METARS_VECTOR_STYLE } from './metars.vector-style';

export const METARS_PRODUCT_DATA: TwcProduct = {
  id: 'metars',
  defaultProductId: '6000',
  productName: 'Weather-Metars-TWC',
  label: 'METARs',
  weatherType: 'METAR',
  description: 'TWC product (vector) - METAR',
  series: 'Observation',
  timeSlicePeriodInMinutes: 60,
  lodMax: 7,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: {
      vectorStyle: TWC_METARS_VECTOR_STYLE
    }
  }
};
